function parseNum(v) {
  const n = typeof v === 'number' ? v : parseFloat(String(v ?? '').replace(',', '.'));
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function isBakimIslemTipi(islemTipi) {
  const t = String(islemTipi ?? '').trim().toLowerCase();
  return t.includes('bakım') || t.includes('bakim');
}

export function isGarantiDahilindeValue(garantiDahilinde) {
  return garantiDahilinde === true || garantiDahilinde === 'true' || garantiDahilinde === 1;
}

export function isGarantiSartlariSaglanmadiValue(val) {
  return val === true || val === 'true' || val === 1;
}

export function checklistHayirVar(checklistCevaplari) {
  if (!Array.isArray(checklistCevaplari)) return false;
  return checklistCevaplari.some((c) => String(c.cevap || '').toLowerCase() === 'hayir');
}

export function computeMusteriTahsilatToplam(randevu, islemTipi, bakimOzeti, opts = {}) {
  const sartSaglanmadi = isGarantiSartlariSaglanmadiValue(
    opts.garantiSartlariSaglanmadi ?? randevu?.garantiSartlariSaglanmadi,
  );
  if (sartSaglanmadi) {
    if (opts.servisBedeli != null && opts.servisBedeli !== '') {
      return parseNum(opts.servisBedeli);
    }
    return parseNum(randevu?.servisBedeli);
  }

  if (isBakimIslemTipi(islemTipi)) {
    const ozet = bakimOzeti || randevu?.bakimOzeti;
    return parseNum(ozet?.bakimFiyatiToplam);
  }

  if (isGarantiDahilindeValue(randevu?.garantiDahilinde)) {
    return 0;
  }

  let toplam = 0;
  for (const i of randevu?.yapilanIslemler || []) {
    const adet = parseNum(i.adet) || 1;
    toplam += parseNum(i.fiyat) * adet;
  }
  for (const i of randevu?.ilaveIslemler || []) {
    const adet = parseNum(i.adet) || 1;
    toplam += parseNum(i.fiyat) * adet;
  }
  for (const p of randevu?.degistirilenParcalar || []) {
    const adet = parseNum(p.adet) || 1;
    toplam += parseNum(p.fiyat) * adet;
  }
  return Math.round(toplam * 100) / 100;
}

export function requiresOdemeSorusu(garantiDahilinde, toplam, islemTipi, opts = {}) {
  if (isGarantiSartlariSaglanmadiValue(opts.garantiSartlariSaglanmadi)) {
    return true;
  }
  if (isBakimIslemTipi(islemTipi)) {
    return true;
  }
  if (isGarantiDahilindeValue(garantiDahilinde)) {
    return false;
  }
  return parseNum(toplam) > 0;
}
